/* eslint-disable @typescript-eslint/no-var-requires */
import { getAppConfig } from '@services/config';
import { axiosLoggerService } from '@services/loggers';

import type { InternalBytelAxiosRequestConfig } from '@app-types/axios';

import axios, { AxiosError, AxiosInstance, AxiosRequestConfig } from 'axios';

const config = getAppConfig();

export function axiosInstanceFactory(external = false): AxiosInstance {
    const proxy = config.proxy.url;

    const axiosConfig: AxiosRequestConfig = {};

    if (external && proxy && typeof window === 'undefined') {
        // Dynamically import proxy agents only on server side

        const { HttpProxyAgent } = require('http-proxy-agent');

        const { HttpsProxyAgent } = require('https-proxy-agent');

        axiosConfig.proxy = false;
        axiosConfig.httpAgent = new HttpProxyAgent(proxy);
        axiosConfig.httpsAgent = new HttpsProxyAgent(proxy);
    }

    const defaultAxiosInstance = axios.create(axiosConfig);

    defaultAxiosInstance.interceptors.request.use((req) => {
        // custom axios options config
        const bytelConfig = req as InternalBytelAxiosRequestConfig;
        bytelConfig.metadata = {
            startDate: Date.now(),
        };

        return bytelConfig;
    });

    defaultAxiosInstance.interceptors.response.use(
        (res) => {
            const config = res.config as InternalBytelAxiosRequestConfig;

            if (config?.next?.mute !== true) {
                axiosLoggerService.logHttpResponse(res);
            }

            return res;
        },
        (error: AxiosError) => {
            const config = error.config as InternalBytelAxiosRequestConfig;

            if (config?.next?.mute !== true) {
                axiosLoggerService.logHttpError(error);
            }

            return Promise.reject(error);
        },
    );

    return defaultAxiosInstance;
}
